module.exports = __webpack_public_path__ + "static/img/9.bb2b3ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/15/sp/9.png
// module id = EJkB
// module chunks = 0